import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const theme = createTheme({
  
  typography: {
    allVariants: {
      color: "#F8FAFF",
    },
    ...rootTheme.typography,
  },
  components: {
  
    MuiIconButton: {
      styleOverrides: {
        root: {
          background: "rgba(0, 136, 245, 0.15)",
          color: "#F8FAFF",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          cursor: 'pointer'
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 30,
          marginBottom: 20,
          color: "#0088F5",
          backgroundColor: "#0088F5",
        },
      },
    },
  },
});
